<template>
	<div class="container">
		<div class="content_wrap d_flex">
			<div ref="sidebar" class="content_menu">
				<tnc-sidebar
					@sidebarClick="handleSidebarClick"
					:items="menu_items"
				></tnc-sidebar>
			</div>
			<div class="content_inner">
				<div ref="content" class="content_a">
					<h1 class="content_title tac">{{ $t('terms.title') }}</h1>
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TncSidebar from '@/components/Menu/TncSidebar.vue';

export default {
	name: 'Terms',
	components: { TncSidebar },
	mounted() {
		window.addEventListener('scroll', this.updateSidebar);
		window.addEventListener('resize', this.updateSidebar);
	},
	beforeUnmount() {
		window.removeEventListener('scroll', this.updateSidebar);
		window.removeEventListener('resize', this.updateSidebar);
	},
	beforeRouteLeave(to, from, next) {
		window.document.documentElement.style.scrollBehavior = '';
		next();
	},

	data() {
		return {
			menu_items: [
				{
					title: 'terms.menu.category1',
					href: 'agreement1',
					children: [
						{
							title: 'terms.menu.title1',
							href: 'agreement1',
						},
						{
							title: 'terms.menu.title2',
							href: 'agreement2',
						},
						{
							title: 'terms.menu.title3',
							href: 'agreement3',
						},
						{
							title: 'terms.menu.title4',
							href: 'agreement4',
						},
						{
							title: 'terms.menu.title5',
							href: 'agreement5',
						},
						{
							title: 'terms.menu.title6',
							href: 'agreement6',
						},
						{
							title: 'terms.menu.title7',
							href: 'agreement7',
						},
						{
							title: 'terms.menu.title8',
							href: 'agreement8',
						},
						{
							title: 'terms.menu.title9',
							href: 'agreement9',
						},
						{
							title: 'terms.menu.title10',
							href: 'agreement10',
						},
						{
							title: 'terms.menu.title11',
							href: 'agreement11',
						},
						{
							title: 'terms.menu.title12',
							href: 'agreement12',
						},
						{
							title: 'terms.menu.title13',
							href: 'agreement13',
						},
					],
				},
				{
					title: this.$t('terms.menu.category2'),
					href: 'Guideline1',
					children: [
						{
							title: 'terms.menu.title14',
							href: 'guideline1',
						},
						{
							title: 'terms.menu.title15',
							href: 'guideline2',
						},
					],
				},
				{
					title: this.$t('terms.menu.category3'),
					href: 'legal_indication1',
					children: [
						{
							title: 'terms.menu.title16',
							href: 'legal_indication1',
						},
						{
							title: 'terms.menu.title17',
							href: 'legal_indication2',
						},
						{
							title: 'terms.menu.title18',
							href: 'legal_indication3',
						},
						{
							title: 'terms.menu.title19',
							href: 'legal_indication4',
						},
						{
							title: 'terms.menu.title20',
							href: 'legal_indication5',
						},
						{
							title: 'terms.menu.title21',
							href: 'legal_indication6',
						},
						{
							title: 'terms.menu.title22',
							href: 'legal_indication7',
						},
						{
							title: 'terms.menu.title23',
							href: 'legal_indication8',
						},
					],
				},
				{
					title: this.$t('terms.menu.category4'),
					href: 'privacy_policy1',
					children: [
						{
							title: 'terms.menu.title24',
							href: 'privacy_policy1',
						},
						{
							title: 'terms.menu.title25',
							href: 'privacy_policy2',
						},
						{
							title: 'terms.menu.title26',
							href: 'privacy_policy3',
						},
					],
				},
			],
		};
	},
	methods: {
		// updateSidebar() {
		// 	let doc = document.documentElement;
		// 	let top = (doc && doc.scrollTop) || document.body.scrollTop;
		// 	const allHeaders = this.$refs.content.querySelectorAll(
		// 		'h1, h2, h3, h4, h5, h6',
		// 	);
		// 	let last;
		// 	for (let i = 0; i < allHeaders.length; i++) {
		// 		let link = allHeaders[i];
		// 		if (link.offsetTop > top) {
		// 			if (!last) last = link;
		// 			break;
		// 		} else {
		// 			last = link;
		// 		}
		// 	}
		// 	if (last && last.id.length) this.setActive(last.id, false);
		// },
		// setActive(id, shouldScrollIntoView) {
		// 	// console.log('aaa');
		// 	const sidebar = this.$refs.sidebar;
		// 	let previousActive = sidebar.querySelector('a.active');
		// 	let currentActive =
		// 		typeof id === 'string'
		// 			? sidebar.querySelector('a[name=' + id + ']')
		// 			: id;
		// 	if (currentActive !== previousActive) {
		// 		if (previousActive) previousActive.classList.remove('active');
		// 		currentActive.classList.add('active');
		// 		if (shouldScrollIntoView) {
		// 			let currentPageOffset = 0;
		// 			let currentActiveOffset =
		// 				currentActive.offsetTop + currentActive.parentNode.clientHeight;
		// 			let sidebarHeight = sidebar.clientHeight;
		// 			let currentActiveIsInView =
		// 				currentActive.offsetTop >= sidebar.scrollTop &&
		// 				currentActiveOffset <= sidebar.scrollTop + sidebarHeight;
		// 			let linkNotFurtherThanSidebarHeight =
		// 				currentActiveOffset - currentPageOffset < sidebarHeight;
		// 			let newScrollTop = currentActiveIsInView
		// 				? sidebar.scrollTop
		// 				: linkNotFurtherThanSidebarHeight
		// 				? currentPageOffset
		// 				: currentActiveOffset - sidebarHeight;
		// 			sidebar.scrollTop = newScrollTop;
		// 		}
		// 	}
		// },
		// moveScroll(href) {
		// 	const offsetTop = document.getElementById(href).offsetTop;
		// 	window.scrollTo({ top: offsetTop });
		// },
		handleSidebarClick(href) {
			// window.document.documentElement.style.scrollBehavior = 'smooth';
			// this.moveScroll(href);
			this.$router.push({ name: href });
		},
	},
};
</script>
